import { useState, useEffect } from "react";

import { ASSET_TYPES } from "../../../constants/assets/types";
import MultiSelectDropdown from "../multiSelect.dropdown";

const CLASSNAMES = {
  multiSelectDropdown: {
    dropdownButton: {
      dropdown:
        "border-animate rounded h-[250px] w-[250px] overflow-y-scroll absolute backdrop-blur-sm bg-greenGlass flex flex-col gap-1 p-2 top-11 z-50",
    },
  },
};

const AssetTypePresetDropdown = ({
  formFields = {},
  setFormFields = () => {},
}) => {
  const [types, setTypes] = useState(ASSET_TYPES);
  const [search, setSearch] = useState("");

  const handleChange = (event) => {
    const { name } = event.target;
    setTypes([
      ...types.map((type) =>
        type.id === name ? { ...type, show: !type.show } : type
      ),
    ]);
  };
  useEffect(() => {
    if (types.length) {
      setFormFields({
        ...formFields,
        assets: {
          asset_types: types.filter((type) => type.show).map((type) => type.id),
        },
      });
    }
  }, [types]);

  const handleSearch = (event) => {
    const { value } = event.target;
    setSearch(value);
  };
  return (
    <MultiSelectDropdown
      classNames={CLASSNAMES.multiSelectDropdown}
      label="Asset Types"
      options={types.filter((type) => {
        if (search === "") return type;
        return type.name?.toLowerCase().includes(search.toLowerCase());
      })}
      handleChange={handleChange}
      search={{
        enabled: true,
        placeholder: "Search...",
        handleSearch,
      }}
    />
  );
};

export default AssetTypePresetDropdown;
